export default __webpack_public_path__ + "static/media/emptyFile.20596d8a.png";